module.exports = __webpack_public_path__ + "static/media/Icon_menu_purchasing_expert.cd85e70c.svg";